import api from '@/api/axios/main.api'

export const fetchEmployee = () => {
  return api.get('/sdm/employee/unit')
}

export const fetchAllEmployee = () => {
  return api.get('/sdm/employee/ambilsemua')
}
